import { Text } from '@cencosud-cencommerce/paris-uikit';

export type TBuyNowErrorCode = {
  error: string;
  isCatMessage?: boolean;
};

export const BuyNowErrorCode = ({ error }: TBuyNowErrorCode) => {
  if (!error) return null;

  return (
    <Text color="neutral-500" weight={600} variant="caption">
      {error}
    </Text>
  );
};
